export const shopDropdownImages = [
  {
    srcSet:
      "/images/nav/new-arrivals_2x.webp 2x, /images/nav/new-arrivals_2x.jpg 2x, /images/nav/new-arrivals_1x.webp 1x, /images/nav/new-arrivals_1x.jpg 1x",
    src: "/images/nav/new-arrivals_1x.jpg",
    alt: "Shop New Arrivals",
    link: "/shop/new-arrivals",
    caption: "New Arrivals",
  },
  {
    srcSet:
      "/images/nav/bestsellers_2x.webp 2x, /images/nav/bestsellers_2x.jpg 2x, /images/nav/bestsellers_1x.webp 1x, /images/nav/bestsellers_1x.jpg 1x",
    src: "/images/nav/bestsellers_1x.jpg",
    alt: "Shop Bestsellers",
    link: "/shop/bestsellers",
    caption: "Bestsellers",
  },
  {
    srcSet:
      "/images/nav/top-rated_2x.webp 2x, /images/nav/top-rated_2x.jpg 2x, /images/nav/top-rated_1x.webp 1x, /images/nav/top-rated_1x.jpg 1x",
    src: "/images/nav/top-rated_1x.jpg",
    alt: "Shop Top Rated Items",
    link: "/shop/top-rated",
    caption: "Top Rated",
  },
];
